import { Toast } from "antd-mobile";
import Services from 'services';
import Library from 'library';
const {JsBridge, Platform,Util} = Library;
const { encryptFuc } = Util;
const PageSize = 20
class Service {
  static activityCode = 'horseYearInvite'
  /**
   * @description 邀新得碎片合成藏品
   * @interface 600920
   * @param {activityCode: 活动编码} params
   * @param { 是否显示加载loading } loading
   *
   */
  static getInitData = async (param = {}, loading = true) => {
    const code = '600920'
    try {
      const params = {
        ...param,
      }
      const ServiceModule = JsBridge.hasWebViewBridge() ? 'MainPage': 'Common'
      const res = await Services(ServiceModule, { code }, params, loading);
      if (res.status > 0) {
        return { data: res.data?.result||res.data };
      } else {
        throw res.message || '请求失败'
      }
    } catch (error) {
      !window.JsBridge.hasWebViewBridge() && Toast.show(error || '请求失败')
    }
  }
  static getFragmentsService = async (param = {}, loading = true) => {
    const code = '600921'
    try {
      const params = {
        ...param,
      }
      const ServiceModule = JsBridge.hasWebViewBridge() ? 'MainPage': 'Common'
      const res = await Services(ServiceModule, { code }, params, loading);
      if (res.status > 0) {
        return { data: res.data?.result||res.data };
      } else {
        throw res.message || '请求失败'
      }
    } catch (error) {
      !window.JsBridge.hasWebViewBridge() && Toast.show(error || '请求失败')
    }
  }
  static fragmentsCompoundService = async (param = {}, loading = true) => {
    const code = '600941'
    try {
      const params = {
        ...param,
      }
      const ServiceModule = JsBridge.hasWebViewBridge() ? 'MainPage': 'Common'
      const res = await Services(ServiceModule, { code }, params, loading);
      if (res.status > 0) {
        return { data: res.data?.result||res.data };
      } else {
        throw res.message || '请求失败'
      }
    } catch (error) {
      !window.JsBridge.hasWebViewBridge() && Toast.show(error || '请求失败')
    }
  }
  static getCompoundList = async (param = {}, loading = true) => {
    const code = '600923'
    try {
      const userInfo = await JsBridge.getCurrentUserInfo();
      const params = {
        ...param,
        // 小程序时优先用传入的 clientId（来自 URL），否则用 userInfo.clientId
        clientId: param.clientId ?? userInfo?.clientId
      }
      console.log('params===>', params)
      const ServiceModule = JsBridge.hasWebViewBridge() ? 'MainPage': 'Common'
      const res = await Services(ServiceModule, { code }, params, loading);
      if (res.status > 0) {
        return { data: res.data?.result||res.data };
      } else {
        throw res.message || '请求失败'
      }
    } catch (error) {
      !window.JsBridge.hasWebViewBridge() && Toast.show(error || '请求失败')
    }
  }

  static loginForClaimShare = async (param = {}, loading = true) => {
    const code = '300504'
    try {
      console.log('params===>', param)
      const ServiceModule = 'MainPage'
      const res = await Services(ServiceModule, { code }, param, loading);
      if (res.status > 0) {
        return { data: res.data?.result||res.data };
      } else {
        throw res.message || '请求失败'
      }
    } catch (error) {
      !window.JsBridge.hasWebViewBridge() && Toast.show(error || '请求失败')
    }
  }

  static collList = async (param = {}, loading = true) => {
    const code = '600942'
    try {
      const userInfo = await JsBridge.getCurrentUserInfo();
      const params = {
        eventType:1,
        clientId: userInfo?.clientId
      }
      console.log('params===>', params)
      const ServiceModule = JsBridge.hasWebViewBridge() ? 'MainPage': 'Common'
      const res = await Services(ServiceModule, { code }, params, loading);
      if (res.status > 0) {
        return { data: res.data?.result||res.data };
      } else {
        throw res.message || '请求失败'
      }
    } catch (error) {
      !window.JsBridge.hasWebViewBridge() && Toast.show(error || '请求失败')
    }
  }
}
export default Service
